<button
  type="button"
  class="cr-bell"
  [class.cr-bell--has-unread]="notifications.unreadCount() > 0"
  (click)="togglePanel($event, panel)"
  aria-label="Benachrichtigungen"
>
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
    <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"/>
    <path d="M10.3 21a1.94 1.94 0 0 0 3.4 0"/>
  </svg>
  @if (notifications.unreadCount() > 0) {
    <span class="cr-bell__badge" aria-live="polite">
      {{ notifications.unreadCount() > 99 ? '99+' : notifications.unreadCount() }}
    </span>
  }
</button>

<p-overlayPanel #panel styleClass="cr-bell-panel" [showCloseIcon]="false" [appendTo]="'body'">
  <div class="cr-bell-panel__header">
    <span class="cr-bell-panel__title">Benachrichtigungen</span>
    @if (notifications.unreadCount() > 0) {
      <button type="button" class="cr-bell-panel__mark-all" (click)="markAll()">
        Alle als gelesen
      </button>
    }
  </div>

  @if (notifications.recent().length === 0) {
    <p class="cr-bell-panel__empty">Du hast aktuell keine Benachrichtigungen.</p>
  } @else {
    <ul class="cr-bell-panel__list">
      @for (item of notifications.recent(); track item.id) {
        <li class="cr-bell-item" [class.cr-bell-item--unread]="!item.read">
          @if (item.link) {
            <a [routerLink]="item.link" (click)="onItemClick(item); panel.hide()" class="cr-bell-item__link">
              <div class="cr-bell-item__title">{{ item.title }}</div>
              <div class="cr-bell-item__body">{{ item.body }}</div>
              <div class="cr-bell-item__time">{{ item.createdAt | date: 'dd.MM. HH:mm' }}</div>
            </a>
          } @else {
            <button type="button" class="cr-bell-item__link" (click)="onItemClick(item)">
              <div class="cr-bell-item__title">{{ item.title }}</div>
              <div class="cr-bell-item__body">{{ item.body }}</div>
              <div class="cr-bell-item__time">{{ item.createdAt | date: 'dd.MM. HH:mm' }}</div>
            </button>
          }
        </li>
      }
    </ul>
    <a routerLink="/benachrichtigungen" (click)="panel.hide()" class="cr-bell-panel__view-all">
      Alle anzeigen
    </a>
  }
</p-overlayPanel>
